import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import PersonMetaData from "../../metadata/PersonMetadata";
import SelectReport from "../searchresults/SelectReport";
import PhoneDetail from "./Platinum/PhoneDetail";
import Counties from "./Counties";
import MoreDetailsAddressHistory from "./MoreDetailsAddressHistory";
import CaseComponent from "../common/CaseComponent";
import { getDate, getDodDate, getMonthAndYear } from "../common/DisplayDate";

class PersonMoreDetails extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
    this.state = {
      hasSearchResults: localStorage.getItem("searchPage"),
    };
  }
  loadData = (props) => {
    const log = _.get(
      props.reportData,
      `${Object.keys(props.reportData)[0]}.log[0]`
    );
    if (log) {
      localStorage.moreDetailsHistoryReportId = _.get(log, "reportID[0]");
      localStorage.moreDetailsHistoryCriteria = _.get(log, "actDesc[0]");
      localStorage.moreDetailsXmlId = _.get(log, "actID[0]");
    }
  };
  redirectToSearch = () => {
    if (window.location.href.indexOf("/search/history") === -1) {
      this.props.history.push("/search/history");
    } else {
      window.location.reload();
    }
  };
  render() {
    const results = [];
    const names = [];
    let isSilverReport = false;
    const { userAccount } = this.props;
    let isGoldReport = _.get(
      this.props.additionalData,
      "isGoldReport",
      false
    );
    if (_.get(this.props.reportData, "personReport.person[0].reportToken[0]") !== undefined)
      isGoldReport = true;
    let personResult;
    if (
      this.props.reportData !== undefined &&
      this.props.reportData !== null &&
      this.props.reportData !== ""
    ) {
      personResult = _.get(this.props.reportData, "personReport.person[0]");
      isSilverReport = _.get(personResult, "reportToken[0]._") !== undefined;
      let name = `${_.get(
        personResult,
        "names[0].name[0].firstName[0]._",
        ""
      )} ${_.get(personResult, "names[0].name[0].middleName[0]._", "")} ${_.get(
        personResult,
        "names[0].name[0].lastName[0]._",
        ""
      )}`;
      let nameNodes = _.get(personResult, "names[0].name");
      if (nameNodes !== undefined && nameNodes.length > 1) {
        nameNodes = _.orderBy(nameNodes, (e) => e.$.internalNameID, ["asc"]);
      }
      const nameCollections = [];
      _.forEach(nameNodes, (nameNode) => {
        const middleInitial = _.get(nameNode, "middleInitial[0]._", "");
        const middleName = _.get(nameNode, "middleName[0]._", "");
        const personName = `${_.get(nameNode, "firstName[0]._", "")} ${middleInitial !== "" ? middleInitial : middleName
          } ${_.get(nameNode, "lastName[0]._", "")}`;
        const internalNameID = _.get(nameNode, "$.internalNameID", "1");
        nameCollections.push({
          internalNameID,
          name: personName,
        });
        if (internalNameID !== "1") {
          names.push(personName);
        } else {
          names.push(personName);
          name = personName;
        }
      });
      const personData = PersonMetaData(personResult, userAccount);
      results.push(
        <Table.Row key={`Person_Name_Row`} className={"report-name-header"}>
          <Table.Cell colSpan={3} className={"icon-align-middle text-center"}>
            {name}
          </Table.Cell>
        </Table.Row>
      );
      if (userAccount.btType !== "4") {
        results.push(
          <Table.Row
            key={`Person_Name_Sens`}
            className={"report-section-header"}
          >
            <Table.Cell colSpan={3} className="icon-align-middle text-center">
              Sensitive Information
              {_.get(
                personResult,
                "SSNInfos[0].SSNInfo[0].SSNDeceased[0]._",
                ""
              ) === "Yes" ? (
                <span> Deceased</span>
              ) : null}
            </Table.Cell>
          </Table.Row>
        );
        let dob = getDate(_.get(personResult, "DOBInfo[0].DOB[0]"));
        if (!dob && isGoldReport) dob = getDate(_.get(personResult, "DOBs[0].DOB[0]"));
        else if (isSilverReport)
          dob = getMonthAndYear(_.get(personResult, "DOBs[0].DOB[0]"));
        const deceased = _.get(personResult, "deceased[0]._", "");
        let dod =
          isSilverReport && deceased.toLowerCase() === "yes"
            ? getMonthAndYear(
              _.get(
                personResult,
                "deceasedRecords[0].deceasedRecord[0].DOD[0]"
              )
            )
            : personData.dod;
        if (isGoldReport)
          dod = getDodDate(_.get(personResult, "deceasedRecords[0].deceasedRecord[0].DOD[0]"), this.props);
        let age = personData.age;
        if (age === undefined || age === "Unknown" || age === "")
          age = _.get(personResult, "DOBs[0].DOB[0].age[0]._", "");
        // if (!isSilverReport) {
        results.push(
          <Table.Row key={`Person_Name_Ssn`}>
            <Table.Cell className={"border-right"}>
              <span className="text-bold">SSN: </span>
              {personData.ssnTiered}
            </Table.Cell>
            <Table.Cell className={"border-right"}>
              <span className="text-bold">ISSUED: </span>
              {isGoldReport
                ?
                _.get(
                  personResult,
                  "SSNRecords[0].SSNRecord[0].years[0]._",
                  ""
                )
                : personData.ssnYear
              }
              <span> in </span>
              {isGoldReport
                ?
                _.get(
                  personResult,
                  "SSNRecords[0].SSNRecord[0].state[0]._",
                  ""
                )
                : personData.ssnLocation
              }
            </Table.Cell>
            <Table.Cell>
              {" "}
              <span className="text-bold padding-left-10">DOB: </span>
              {dob}
              {dod !== "" && dod !== "N/A" ? (<span>
                <span className="text-bold padding-left-10"> DOD: </span>{dod}
                <span className="text-bold padding-left-10"> Age at Death: </span>{_.get(
                  personResult,
                  "deceasedRecords[0].deceasedRecord[0].ageAtDeath[0]._", ""
                )}
              </span>
              ) : (
                <span>
                  <span className="text-bold padding-left-10"> AGE: </span> {age}
                </span>
              )}
            </Table.Cell>
          </Table.Row>
        );
      }
      results.push(
        <Table.Row key={`Person_Name_Sel_Rep`}>
          <Table.Cell colSpan={3}>
            <SelectReport
              name={name}
              nameCollections={nameCollections}
              internalId={_.get(this.props.additionalData, "internalID")}
              selectReportTitle={"Get More Detailed Information For"}
              isSilverReport={isSilverReport}
              isGoldReport={isGoldReport}
              {...this.props}
            />
          </Table.Cell>
        </Table.Row>
      );
    }
    return (
      <div id="report">
        <Table stackable key={"Person_Header_Name"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell width={4}>
                <div className={`no-print`}>
                  {/* {window.location.href.indexOf("/search/history") === -1 &&
                    localStorage.historyReportId !== "" &&
                    localStorage.xmlId !== "" && (
                      <Button
                        // className="ui button float-right margin-top-botton-5"
                        className={"margin-left-10"}
                        onClick={this.redirectToSearch}
                      >
                        Back
                      </Button>
                    )} */}
                  <Button
                    className={"margin-left-10"}
                    onClick={() => this.props.printContent("report", `Report`)}
                  >
                    Print
                  </Button>
                </div>
              </Table.Cell>
              <Table.Cell />
              <Table.Cell width={6} textAlign={`right`}>
                <div className={`no-print`}>
                  <CaseComponent
                    {...this.props}
                    actId={_.get(
                      this.props.reportData,
                      "personReport.log[0].actID[0]"
                    )}
                    compType={"result"}
                  />
                </div>
              </Table.Cell>
            </Table.Row>
            {results}
          </Table.Body>
        </Table>
        <Table
          className={"table-no-border-and-padding"}
          stackable
          key={"Person_Row_Phone_Counties"}
        >
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan={2}>
                {names.length > 0 ? (
                  <Table stackable key={"Person_Possible_Aliasses"}>
                    <Table.Body>
                      <Table.Row className="report-section-header">
                        <Table.Cell
                          className={
                            userAccount.acctTheme === 0
                              ? "text-center informational_bar"
                              : "text-center"
                          }
                        >
                          Possible Aliases
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>{_.join(names, ", ")}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                ) : null}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <PhoneDetail
                  {...this.props}
                  node={personResult}
                  isSilverReport={isSilverReport}
                  displayCarrier={!this.props.isPlatinumReport}
                />
              </Table.Cell>
              <Table.Cell>
                <Counties {...this.props} node={personResult} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <MoreDetailsAddressHistory {...this.props} node={personResult} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userAccount: state.userAccount,
  };
}
export default connect(mapStateToProps, null)(PersonMoreDetails);



// WEBPACK FOOTER //
// ./src/components/reports/PersonMoreDetails.js